// extracted by mini-css-extract-plugin
export default {"root":"GroupListHeader_root__5JbqD","sortText":"GroupListHeader_sortText__yCqam","hidden":"GroupListHeader_hidden__X0DcH"};